<template lang="pug">
.specs
  .category
    span.title Material
    dl.list
      dt.label Connectors
      dd.data
        span {{ products.connectors[0].sku }}
        span {{ products.connectors[0].name }} 
        span {{ products.connectors[1].sku }}
        span {{ products.connectors[1].name }} 
      dt.label Cable
      dd.data 
        span {{ products.cable.name }}
      dt.label(v-if = "!products.configID.includes('MSLPSMA-085-MSLPSMA')") Shrink Tubing
      dd.data(v-if = "!products.configID.includes('MSLPSMA-085-MSLPSMA')")
        span {{ products.cable.shrinkTubing }}
  .category
    span.title Performance
    dl.list
      dt.label Impedance
      dd.data {{ products.performance.impedance }}
      dt.label Freq. Range
      dd.data {{ products.performance.freqrange }}
      dt.label VSWR
      dd.data  <span v-html=" products.performance.vswr"></span>
      dt.label Insertion Loss
      dd.data <span v-html="products.performance.insertionLoss"></span>
  .category
    span.title Notes
    ol.list
      li.data(v-for="note in notes") <span v-html="note"></span> 
   
</template>
<script>
export default {
  name: "MouserProductSheetSpecs",
  props: ["products", "notes"],
};
</script>


<style lang="scss" scoped>
.specs {
  flex: 1 1 100%;
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: auto 1fr;
  padding: 1rem 1rem 1rem 2rem;
  gap: 0.5rem 0.75rem;
}

.category {
  display: contents;
}

span.title {
  grid-area: span 1 / span 2;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  .category:not(:first-child) & {
    margin-top: 2rem;
  }
}

.list {
  display: contents;
  margin: 0;
  &:is(ol) {
    list-style: none;
    counter-reset: orderedlist;
  }
}

.label {
  grid-area: span 1 / span 1;
  font-size: 0.75rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.25px;
  &::after {
    content: ":";
  }
}

.data {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  grid-area: span 1 / span 1;
  font-size: 0.75rem;
  font-weight: 400;
  margin: 0;
  a {
    color: $blue;
    text-decoration: none;
  }
  &:is(li) {
    flex-direction: row;
    grid-area: span 1 / span 2;
    counter-increment: orderedlist;
    &:before {
      content: counter(orderedlist) ". ";
    }
  }
}
</style>